import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import type { TemplateKind, TemplateLang, TemplateRowKey } from '@/api/notificationTemplates';
import { PageHeader } from '@/components/ui/PageHeader';
import { SERVER_LANGS } from '@/lib/notificationTemplates';

import { Matrix } from './notificationTemplates/Matrix';
import { TemplateCard } from './notificationTemplates/TemplateCard';

/**
 * Админка «Тексты уведомлений» (D45, договор
 * `docs/CONTRACTS/notification-templates.md`). Тексты живут в базе с версиями и
 * историей, правка видна людям сразу — выката не нужно.
 *
 * ⚠️ ТОЛЬКО admin, И ЭТО ЗАКРЫТО В ТРЁХ МЕСТАХ: маршрут под `RequireAdmin`
 * (менеджер уходит на `/admin`), пункт меню в наборе «только директор» в
 * `AppShell`, ручки службы — `RequireRole("admin")`. Текст уходит полутора
 * тысячам человек разом, и менеджеру такой рычаг не дают.
 *
 * Состояние в адресе: `?key=&variant=&lang=&kind=` — карточкой можно поделиться
 * ссылкой, маршрут при этом один (так же сделано у движка ИИ-заданий).
 */
export function AdminNotificationTemplatesPage() {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();

  const key = (params.get('key') ?? '').trim();
  const rawLang = params.get('lang') ?? '';
  const lang = (SERVER_LANGS as readonly string[]).includes(rawLang) ? (rawLang as TemplateLang) : null;
  const kind: TemplateKind = params.get('kind') === 'email_texts' ? 'email_texts' : 'template';
  const variant = params.get('variant') ?? '';

  const open: TemplateRowKey | null = key && lang ? { kind, key, variant, lang } : null;

  return (
    <>
      <PageHeader
        title={t('adminNotificationTemplates.title')}
        subtitle={t('adminNotificationTemplates.subtitle')}
      />

      {open ? (
        <TemplateCard rowKey={open} onBack={() => setParams(new URLSearchParams())} />
      ) : (
        <Matrix
          onOpen={(row, cellLang) => {
            const next = new URLSearchParams();
            next.set('key', row.key);
            next.set('lang', cellLang);
            if (row.variant) next.set('variant', row.variant);
            if (row.kind !== 'template') next.set('kind', row.kind);
            setParams(next);
          }}
        />
      )}
    </>
  );
}
